import { Navigate, Outlet } from "react-router-dom";
import { canAccessReportes } from "../helpers/session";

const RequireReportesAccess: React.FC = () => {
  if (!canAccessReportes()) {
    return <Navigate to="/inicio" replace />;
  }
  return <Outlet />;
};

export default RequireReportesAccess;
